import { Feature } from '@tencent/workbench';
import BaseMobileContextMenuFeature from '@framework/workbench/common/feature/base-mobile-context-feature';
import { config } from './config';
import AttachmentUploader from '@src/js/common/ark-extensions/dc-components/attachment-uploader';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import { TDWActionType, TDWModuleType, TDWOperationType } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import { getAttachmentObjKey } from '@src/slide/domain/ui-model/element-modeles/property/attachment/utils/attachment';

@Feature()
export class DownloadAttachmentFeature extends BaseMobileContextMenuFeature {
    public id = config.name;

    public downloadAttachment(): void {
        const model = this.getSelectionService().selectedElements.getCurrentModel();
        const objKey = getAttachmentObjKey(model);
        if (!objKey) {
            return;
        }
        AttachmentUploader.getInstance().download(objKey);

        // 上报下载附件
        tdw({
            opername: TDWOperationType.DOC_WORD_EDITOR,
            module: TDWModuleType.LOCAL_FILES,
            action: TDWActionType.DOWNLOAD_CLICK,
        });
    }
}
